import React from "react"

import InputTextElement from "./InputTextElement";

const InputNumberControl = (props) => {
    const {
        editing,
        required,
        name,
        label,
        autoFocus,
        placeholder,
        type = "number",
        hint,
        icon,
        haserror,
        disabled,
        minvalue,
        maxvalue,
        step,
        className = "",
        watchfunction = null,
        mirrorField,
        value,
        onChange,
        error,
    } = props;
    let { readonly } = props;
    if (!editing) readonly = true;


    const slotProps = {
        input: {
            min: minvalue,
            max: maxvalue,
            step: step
        },
    };


    return (
        <InputTextElement
            id={name}
            name={name}
            value={value}
            type={type}
            label={label}
            placeholder={placeholder}
            icon={icon}
            hint={hint}
            error={error}
            invalid={Boolean(error) || haserror}
            editing={editing}
            required={required}
            autoFocus={autoFocus}
            disabled={disabled}
            readonly={readonly}
            slotProps={slotProps}
            className={className}
            onChange={onChange}
            watchfunction={watchfunction}
            mirrorField={mirrorField}
        />
    );
};


export default InputNumberControl;
